<template>
  <el-dialog
    v-el-drag-dialog
    :visible.sync="innerVisible"
    :title="$t('Viewer.email')"
    width="750px"
    :close-on-click-modal="false"
    class="app-main-inner"
  >
    <div class="app-main-inner-row">
      <el-radio-group v-show="!isQuotation" v-model="customerType" no="customerType" @change="otherHandler()">
        <el-radio :label="1">{{ $t('SeaExport.Customer') }}</el-radio>
        <el-radio :label="2">{{ $t('SeaExport.ShippingCmp') }}</el-radio>
        <el-radio :label="3">{{ $t('SeaExport.BookingAgent') }}</el-radio>
        <el-radio :label="4">{{ $t('SeaExport.LocalAgent') }}</el-radio>
        <el-radio :label="5">{{ $t('SeaExport.UpDestAgent') }}</el-radio>
        <el-radio :label="6">{{ $t('SeaExport.NominatedAgent') }}</el-radio>
        <el-radio :label="7">{{ $t('SeaExport.Haulage') }}</el-radio>
        <el-radio :label="8">{{ $t('SeaExport.Warehouse') }}</el-radio>
        <el-radio :label="9">{{ $t('SeaExport.EmailGroup') }}</el-radio>
        <el-radio :label="10">{{ $t('Message.Shipper') }}</el-radio>
        <el-radio :label="11">{{ $t('Message.Consignee') }}</el-radio>
        <el-radio :label="12">{{ $t('Message.Notify') }}</el-radio>
      </el-radio-group>
      <el-form
        label-width="90px"
        label-position="left"
        inline
      >
        <el-form-item v-if="!isEmailGroup" class="long" :label="$t('SeaExport.CompanyName')">
          <cargo-company-select
            no="customerTypeName"
            :method-params="{[customerTypeName]:true}"
            :default-value="customerId||''"
            style="width: 100%"
            @change="customerIdChange"
          />
        </el-form-item>
        <el-form-item v-if="!isEmailGroup" class="long" :label="$t('SeaExport.Receiver2')">
          <el-select
            v-if="source === 'tabMBL' || source === 'tabHBL' || source === 'tabMBL2' || source === 'tabHBL2'"
            v-model="emailToList"
            no="emailFormTo"
            filterable
            multiple
            allow-create
            @clear="onClear"
            @change="emailToChange"
          >
            <el-option
              v-for="(item,index) in contactList"
              :key="index"
              :label="item.name"
              :value="item.name"
            />
          </el-select>
          <cargo-combo-box
            v-else
            v-model="emailForm.to"
            no="emailFormTo"
            :allow-create="true"
            :clearable="true"
            :options="contactList"
            :label-function="labelFunction"
            value-field="email"
            :forbid-values="['']"
            @clear="onClear"
          />
        </el-form-item>
        <el-form-item v-if="isEmailGroup" class="long placeholder-margin" :label="$t('SeaExport.Receiver2')">
          <el-select
            v-model="emailGroupTo"
            no="emailGroupTo"
            :filterable="true"
            multiple
            :clearable="true"
            @clear="onClear"
            @change="emailGroupToChange"
          >
            <el-option
              v-for="(item,index) in emailGroupToList"
              :key="index"
              :label="item.groupName"
              :value="item.uuid"
            />
          </el-select>
        </el-form-item>
        <el-form-item class="long2" :label="$t('CargoMsg.Cargo_EmailTemplate')">
          <span style="display: flex;">
            <el-checkbox v-model="emailTemplate" no="emailTemplate" style="padding-right: 15px;" @change="emailTemplateCheck">{{ $t('SeaExport.EmailTemplate') }}</el-checkbox>
            <cargo-combo-box
              v-model="emailForm.emailTitle"
              :disabled="!emailTemplate"
              no="emailTemplateList"
              style="width:420px"
              :allow-create="true"
              :clearable="true"
              :options="emailTemplateList"
              :placeholder-val="$t('SeaExport.placeholderVal')"
              :label-function="titleLabelFunction"
              value-field="uuid"
              :forbid-values="['']"
              @change="(item)=> { emailTemplateChange('change', item)}"
              @clear="onClearTitle"
            />
          </span>
        </el-form-item>
        <el-form-item class="long" :label="$t('Viewer.title')">
          <span style="display: flex;">
            <el-input v-model="emailForm.title" no="title" />
          </span>
        </el-form-item>
        <el-form-item v-if="emailGroup" class="long placeholder-margin" :label="$t('SeaExport.Cc') + $t('SeaExport.EmailGroup')">
          <el-select
            v-model="emailGroupCc"
            no="emailGroupCc"
            :filterable="true"
            multiple
            :clearable="true"
            @clear="onClearCc"
            @change="emailGroupCcChange"
          >
            <el-option
              v-for="(item,index) in emailGroupCcList"
              :key="index"
              :label="item.groupName"
              :value="item.uuid"
            />
          </el-select>
        </el-form-item>
        <el-form-item class="long" :label="$t('SeaExport.Cc')">
          <el-input v-model="emailForm.cc" no="emailFormCc" type="textarea" :rows="5" />
        </el-form-item>
        <el-form-item class="long" :label="isCopyLink?$t('Viewer.BlAddress'):$t('Viewer.content')">
          <el-tooltip v-show="isCopyLink" :content="$t('Message.YouTheLinkAddressDirectly')" placement="right">
            <el-input v-model="emailForm.content" no="content" type="textarea" :rows="5" />
          </el-tooltip>
          <el-input
            v-show="!isCopyLink"
            v-model="emailForm.content"
            no="textarea"
            type="textarea"
            :rows="5"
            label="sefwe"
          />
        </el-form-item>
        <el-form-item class="long" style="margin-left: 90px;">
          <el-button no="copyLink" type="primary" @click="onCopyLink">{{ $t('SeaExport.copyLink') }}</el-button>
          <el-button no="openLink" type="primary" @click="onOpenLink">{{ $t('SeaExport.openLink') }}</el-button>
        </el-form-item>

        <div>
          <el-checkbox v-model="sales" no="sales" :disabled="emailGroup" @change="ccChangeHandler('sales',sales)">{{ $t('SeaExport.Sales') }}</el-checkbox>
          <el-checkbox v-model="op" no="op" :disabled="emailGroup" @change="ccChangeHandler('op',op)">{{ $t('SeaExport.Operation') }}</el-checkbox>
          <el-checkbox v-model="csr" no="csr" :disabled="emailGroup" @change="ccChangeHandler('csr',csr)">{{ $t('SeaExport.CustomerService') }}</el-checkbox>
          <el-checkbox v-model="doc" no="doc" :disabled="emailGroup" @change="ccChangeHandler('doc',doc)">{{ $t('SeaExport.Documents') }}</el-checkbox>
          <el-checkbox v-model="emailGroup" no="emailGroup" @change="ccChangeHandler('sales', emailGroup)">{{ $t('SeaExport.EmailGroup') }}</el-checkbox>
          <el-checkbox v-model="defaultCc" no="defaultCc" :disabled="emailGroup">{{ $t('SeaExport.SaveTheDefaultCC') }}</el-checkbox>
        </div>

        <!-- 邮件内容 -->
        <el-form-item class="long" style="height: auto" :label="$t('SeaExport.MailContent')">
          <quill-editor
            v-model="emailForm.mailContent"
            :options="editorOption"
            style="height: auto;"
            class="my-custom-quill-editor-email-input"
          />
        </el-form-item>

        <!-- 发送邮箱 -->
        <el-form-item class="long" :label="$t('SeaExport.SendEMail')">
          <el-select v-model="emailForm.mailType" no="mailType" :placeholder="$t('SeaExport.SystemEmail')">
            <el-option v-for="(item, index) in sendEmailList" :key="index" :label="item.name" :value="item.id" />
          </el-select>
        </el-form-item>
      </el-form>
    </div>
    <div slot="footer">
      <el-button
        type="primary"
        plain
        @click="localEmailClickHandler"
      >{{ $t('SeaExport.InvokeLocalMailClient') }}</el-button>
      <el-button no="Send" type="primary" @click="okClickHandler">{{ $t('SeaExport.Send') }}</el-button>
      <el-button no="Cancel" @click="innerVisible=false">{{ $t('common.btn.cancel') }}</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { fileHistorySendEmailService, getSetMailTemplate } from '@/api/sendEmailService'
import cargoCompanySelect from '@/components/Cargo/Common/cargoCompanySelect'
import { Company } from '@/class/model/mdm/Company'
import * as userApi from '@/api/user'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import { resolveSpecificField2Value } from '@/utils/basicDataCache'
import LocalStorageUtilsNew from '@/utils/localStorageUtilsNew'
import cargoComboBox from '@/components/Cargo/Common/cargoComboBox'
import { getMailGroupList } from '@/api/basicData/mailGroup'
import { quillEditor } from 'vue-quill-editor'
import { cache, cacheName } from '@/utils/cacheManager'
import { getLoading } from '@/utils/utilBaseElement'

export default {
  name: 'EmailInput',
  components: { cargoComboBox, cargoCompanySelect, quillEditor },
  props: {
    visible: { type: Boolean, required: true },
    context: {
      type: Object,
      required: true
    },
    job: {
      type: Object,
      required: true
    },
    jobEamilData: {
      type: Object,
      required: true
    },
    isQuotation: {
      type: Boolean,
      default: false
    },
    isCopyLink: {
      type: Boolean,
      default: false
    },
    sendEmailData: {
      type: Object,
      required: true
    },
    sendCallBack: {
      type: Function,
      default: null
    },
    pushLink: {
      type: Number,
      default: 0
    },
    source: {
      type: String,
      default: ''
    } // 来源
  },
  data() {
    return {
      editorOption: {
        modules: {
          toolbar: {
            container: [
              ['bold', 'italic', 'underline', 'strike'], // 加粗 斜体 下划线 删除线
              ['link'],
              ['blockquote', 'code-block'], // 引用  代码块
              [{ header: [1, 2, 3, 4, 5, 6, false] }], // 标题
              ['clean'] // 清除文本格式
            ]
          }
        }
      },
      innerVisible: false,
      customerType: 1,
      customerTypeName: 'customer',
      contactList: [],
      customerId: this.job.customerId,
      ccList: [],
      sendEmailList: [
        {
          name: this.$t('SeaExport.SystemEmail'),
          id: '0'
        }
      ],
      sales: '',
      op: '',
      csr: '',
      doc: '',
      emailGroup: '', // 抄送邮件群组
      defaultCc: '',
      emailGroupTo: [], // 收件人邮件群组
      emailGroupCc: [], // 抄送邮件群组
      emailTemplate: '', // 邮件模板
      emailTemplateList: [], // 邮件模板
      emailGroupToList: [], // 收件人邮件群组
      emailGroupCcList: [], // 抄送人邮件群组
      emailForm: {
        to: '',
        cc: '',
        title: '',
        emailTitle: '',
        content: '',
        ids: '',
        mailType: '0',
        pushLink: '',
        mailContent: ''
      },
      emailToList: [],
      mailContent: '', // 邮件内容
      overseasMailContent: '' // 当客商为指定货代理时的邮件内容
      // storageMailContent: ''
    }
  },
  computed: {
    isEmailGroup() {
      return this.customerType && Number(this.customerType) === 9
    }
  },
  watch: {
    visible(newVal) {
      this.innerVisible = newVal
      if (newVal) {
        // this.toQuery()
      }
    },
    innerVisible(newVal) {
      if (!newVal) {
        // this.rowData = []
      }
      this.$emit('update:visible', newVal)
    }
    // 'emailForm.mailContent': {
    //   handler(content) {
    //     if(!this.emailTemplate) {
    //       this.storageMailContent = content
    //     }
    //   }
    // }
  },
  async created() {
    await cache.load(cacheName.CONFIG)
    if (this.visible) {
      this.innerVisible = true
    }
    await this.initEmailGroupList()
    this.initEmailTemplateList()
    // 加载缓存数据
    const localObj = LocalStorageUtilsNew.getConfiguration(this.source + 'EmailInput' + this.customerType)
    if (localObj) {
      this.doLocalCache(localObj)
    }
    this.initContactList({ cmpIdx: this.customerId })
    this.emailForm.title = this.sendEmailData.emailTitle
    this.emailForm.content = this.sendEmailData.emailContent
    this.emailForm.ids = this.sendEmailData.fileIdList
    if (!localObj) {
      this.reloadDefaultEmailChange()
    }
    this.getSetMailTemplateFunc()
    this.getEamilStatus()
  },
  methods: {
    // 获取发送邮箱可勾选项
    async getEamilStatus() {
      const data = {
        branchId: this.$store.getters.currentOfficeId,
        enable: 1
      }
      const personalInfo = await userApi.getPersonalEmail(data).then(resp => resp.data)
      if (personalInfo) {
        personalInfo.map((item) => {
          switch (item.mailType) {
            case '1':
              this.sendEmailList.push({
                name: this.$t('SeaExport.CompanyMail'),
                id: '1'
              })
              break
            case '2':
              this.sendEmailList.push({
                name: this.$t('SeaExport.PersonalMailbox'),
                id: '2'
              })
              break
          }
        })
      }
    },
    // 获取邮件内容
    async getSetMailTemplateFunc(changeData, type) {
      this.loading = getLoading()
      let data = {}
      // 根据模板类型判断传递的pushLink的值
      if (this.jobEamilData.templateType === 'MBL' || this.jobEamilData.templateType === 'MBL2') {
        if (type === 'change') {
          changeData.pushLink = '2'
        } else {
          this.emailForm.pushLink = '2'
        }
      }
      if (this.jobEamilData.templateType === 'HBL' || this.jobEamilData.templateType === 'HBL2') {
        if (type === 'change') {
          changeData.pushLink = '3'
        } else {
          this.emailForm.pushLink = '3'
        }
      }
      if (type === 'change') {
        data = {
          ...changeData
        }
      } else {
        data = {
          ...this.jobEamilData,
          pushLink: this.emailForm.pushLink
        }
      }
      const res = await getSetMailTemplate(data).finally(() => {
        this.loading.close()
      })
      if (res.ok) {
        const OpenXHQDocumentCenter = cache.config.get('OpenXHQDocumentCenter') !== '0'
        if (OpenXHQDocumentCenter && this.sendEmailData) { // 开启了信号旗单证中心的参数，邮件内容为需要把【对单地址】替换成【海外代理对单链接地址】
          let contentTemplate = res.data.contentTemplate
          contentTemplate = contentTemplate.replace(/ /g, '&nbsp;').replace(/\$\{对单地址}/g, '<a href="' + this.sendEmailData.overseasLink + '" target="_blank">' + this.sendEmailData.overseasLink + '</a>')
          this.overseasMailContent = contentTemplate
        }
        // 根据已有接口获取到的对单地址，替换邮件内容中的匹配到的'对单地址'字符
        // CARGO-31403 邀请对单的网址邮件导出后无超链接
        if (res.data.contentTemplate) {
          // MBL,HBL邀请对单的时候，不需要替换，已经在后端处理过了
          const address = '<a href=\"' + this.emailForm.content + '\" target=\"_blank\">' + this.emailForm.content + '</a>'
          res.data.contentTemplate = res.data.contentTemplate.replace('${对单地址}', address)

          // if (!['2', '3'].includes(data.pushLink)) {
          //   res.data.contentTemplate = res.data.contentTemplate.replace(/ /g, '&nbsp;').replace(/\$\{对单地址}/g, '<a href="' + this.emailForm.content + '" target="_blank">' + this.emailForm.content + '</a>')
          // }
          this.mailContent = res.data.contentTemplate
        }
        this.emailForm.mailContent = this.mailContent
        if (OpenXHQDocumentCenter && (this.customerType === 6)) { // 开启了信号旗单证中心的参数且客商为指定货代理时，邮件内容为需要把【对单地址】替换成【海外代理对单链接地址】
          this.emailForm.mailContent = this.overseasMailContent
          this.emailForm.content = this.sendEmailData.overseasLink
        }
        // if(type !== 'change') {
        //   this.storageMailContent = this.emailForm.mailContent
        // }
      }
    },
    saveCCEmail() {
      const ccObject = {}
      if (this.defaultCc) {
        // eslint-disable-next-line eqeqeq
        if (this.sales && !this.job.sales !== '') {
          ccObject.sales = resolveSpecificField2Value(TYPE_NAMES.basic_data_User, 'userId', this.job.sales, 'email')
        }
        if (this.op && !this.job.op !== '') {
          ccObject.op = resolveSpecificField2Value(TYPE_NAMES.basic_data_User, 'userId', this.job.op, 'email')
        }
        if (this.csr && !this.job.csr !== '') {
          ccObject.csr = resolveSpecificField2Value(TYPE_NAMES.basic_data_User, 'userId', this.job.csr, 'email')
        }
        if (this.doc && !this.job.dc !== '') {
          ccObject.doc = resolveSpecificField2Value(TYPE_NAMES.basic_data_User, 'userId', this.job.dc, 'email')
        }
        if (this.defaultCc) {
          ccObject.defaultCc = this.defaultCc
        }
      }
      window.localStorage.setItem('defaultCC', JSON.stringify(ccObject))
    },
    // 抄送信息改变
    ccChangeHandler(p, check) {
      if (this.emailGroup) {
        this.emailForm.cc = ''
        this.ccList = []
        this.sales = this.op = this.doc = this.csr = ''
      }
      let cc = this.emailForm.cc
      if (cc !== '') {
        cc = cc.replace(/\n/g, '')
        this.ccList = cc.split(',')
      }
      if (this.job[p] !== '' && !this.emailGroup) {
        const email = resolveSpecificField2Value(TYPE_NAMES.basic_data_User, 'userId', this.job[p], 'email')
        if (check) {
          if (email !== '' && !this.ccList.includes(email)) {
            this.ccList.push(email)
          }
        } else {
          this.ccList = this.ccList.filter(value => {
            return value !== email
          })
        }
      }
      // 刷新CC内容
      this.refreshCcTxt()
    },
    refreshCcTxt() {
      let ccEmail = ''
      for (let i = 0; i < this.ccList.length; i++) {
        if (ccEmail === '') {
          ccEmail = this.ccList[i]
        } else {
          ccEmail = ccEmail + ',\n' + this.ccList[i]
        }
      }
      this.emailForm.cc = ccEmail
    },
    async reloadDefaultEmailChange() {
      const ccItem = JSON.parse(window.localStorage.getItem('defaultCC'))
      if (ccItem !== null) {
        if (ccItem.hasOwnProperty('sales') && this.job.sales !== '') {
          this.sales = true
          const userEmail = resolveSpecificField2Value(TYPE_NAMES.basic_data_User, 'userId', this.job.sales, 'email')
          if (userEmail !== '') {
            this.ccList.push(userEmail)
          }
        }
        if (ccItem.hasOwnProperty('op') && this.job.op !== '') {
          this.op = true
          const userEmail = resolveSpecificField2Value(TYPE_NAMES.basic_data_User, 'userId', this.job.op, 'email')
          if (userEmail !== '') {
            this.ccList.push(userEmail)
          }
        }
        if (ccItem.hasOwnProperty('csr') && this.job.csr !== '') {
          this.csr = true
          const userEmail = resolveSpecificField2Value(TYPE_NAMES.basic_data_User, 'userId', this.job.csr, 'email')
          if (userEmail !== '') {
            this.ccList.push(userEmail)
          }
        }
        if (ccItem.hasOwnProperty('doc') && this.job.dc !== '') {
          this.doc = true
          const userEmail = resolveSpecificField2Value(TYPE_NAMES.basic_data_User, 'userId', this.job.dc, 'email')
          if (userEmail !== '') {
            this.ccList.push(userEmail)
          }
        }
        if (ccItem.hasOwnProperty('defaultCc')) {
          this.defaultCc = true
        }
      }
      // 如果自己有操作，销售，单证，客户权限则默认选中
      if (this.$checkPermission(['role_sales']) && this.job.sales !== '' && !this.sales) {
        const userEmail = resolveSpecificField2Value(TYPE_NAMES.basic_data_User, 'userId', this.job.sales, 'email')
        if (userEmail !== '') {
          this.sales = true
          this.ccList.push(userEmail)
        }
      }
      if (this.$checkPermission(['role_op']) && this.job.op !== '' && !this.op) {
        const userEmail = resolveSpecificField2Value(TYPE_NAMES.basic_data_User, 'userId', this.job.op, 'email')
        if (userEmail !== '') {
          this.op = true
          this.ccList.push(userEmail)
        }
      }
      if (this.$checkPermission(['role_csr']) && this.job.csr !== '' && !this.csr) {
        const userEmail = resolveSpecificField2Value(TYPE_NAMES.basic_data_User, 'userId', this.job.csr, 'email')
        if (userEmail !== '') {
          this.csr = true
          this.ccList.push(userEmail)
        }
      }
      if (this.$checkPermission(['role_doc']) && this.job.dc !== '' && !this.doc) {
        const userEmail = resolveSpecificField2Value(TYPE_NAMES.basic_data_User, 'userId', this.job.dc, 'email')
        if (userEmail !== '') {
          this.doc = true
          this.ccList.push(userEmail)
        }
      }
      // 刷新CC内容
      this.refreshCcTxt()
    },
    labelFunction(item) {
      return `${item.name}`
    },
    onClear(val) {
      this.emailForm.to = ''
      this.emailToList = []
    },
    // 等同于cargoware 中的 方法 loadContactsResultHandler
    async customerIdChange(company) {
      this.emailForm.to = ''
      this.emailToList = []
      this.contactList = null
      this.getCompany(company)
    },
    getCompany(company) {
      // todo 服务端是否有缓存数据
      this.loadContactsResultHandler(company)
    },
    async loadContactsResultHandler(company) {
      company = new Company(company)
      const contacts = await company.getContactsBycmpIdx()
      this.buildContactsData(contacts)
    },
    getCarrierCompany(company) {
      this.emailForm.to = ''
      this.emailToList = []
      this.contactList = null
      this.loadCarrierContactsResultHandler(company)
    },
    async loadCarrierContactsResultHandler(company) {
      company = new Company(company)
      const contacts = await company.getContactsBycmpIdx()
      if (contacts == null || contacts.length === 0) {
        return
      }
      const newContactList = []
      const vesselLineEmailList = []
      // 获取航线代码
      const vesselLine = this.getVesselLine()
      for (const contact of contacts) {
        const item = this.convertContactToEmail(contact)
        if (vesselLine !== '' && contact.airline === vesselLine) {
          vesselLineEmailList.push(item)
        } else {
          newContactList.push(item)
        }
      }
      if (vesselLineEmailList !== null && vesselLineEmailList.length > 0) {
        this.contactList = vesselLineEmailList
        this.emailForm.to = this.contactList[0].name
        this.emailToList = [this.contactList[0].name]
      } else if (newContactList !== null && newContactList.length > 0) {
        this.contactList = newContactList
        this.emailForm.to = this.contactList[0].name
        this.emailToList = [this.contactList[0].name]
      }
    },
    /* 车队信息*/
    loadTruckingResultHandler() {
      // todo 业务信息暂未获取车队信息
      // this.customerId = this.job.trucking[0]
      this.getCompany({ cmpIdx: this.customerId })
    },
    /* 查询内装仓库信息*/
    loadWarehouseSuccess() {
      // todo 业务信息暂未获取仓库信息
      // this.customerId = this.job.warehouseInfo[0]
      this.getCompany({ cmpIdx: this.customerId })
    },
    /* 初始时赋值收件人(联系人)*/
    async initContactList(company) {
      company = new Company(company)
      const contacts = await company.getContactsBycmpIdx()
      this.buildContactsData(contacts)
    },
    getVesselLine() {
      const region = resolveSpecificField2Value(TYPE_NAMES.basic_data_Seaport, 'code', this.job.dischargingPortCode, 'region')
      return region
    },
    buildContactsData(contacts) {
      if (!contacts) {
        return
      }
      // 获取job 上的联系人
      const defaultContactObj = this.getDefaultEmail(contacts)
      const newContactList = []
      let defalutContactEmail = ''
      for (const item of contacts) {
        if (!item.email) continue
        const obj = {
          name: `[${item.contactPerson}]${item.email}`,
          contact: item.contactPerson,
          email: item.email
        }
        if (defaultContactObj !== null && defaultContactObj.name === obj.name) {
          defalutContactEmail = item.email
        }
        newContactList.push(obj)
      }
      this.contactList = newContactList

      if (!(this.contactList != null && this.contactList.length > 0)) {
        return
      }
      this.emailForm.to = this.contactList[0].email
      this.emailToList = [this.contactList[0].email]
      if (defalutContactEmail !== '') {
        this.emailForm.to = defalutContactEmail
        this.emailToList = [defalutContactEmail]
      }
    },
    convertContactToEmail(contact) {
      let obj = {}
      if (contact.email) {
        obj = {
          name: `[${contact.contactPerson}]${contact.email}`,
          contact: contact.contactPerson,
          email: contact.email
        }
      } else {
        obj = {
          name: `[${contact.contactPerson}]`,
          contact: contact.contactPerson,
          email: ''
        }
      }
      return obj
    },
    /* 邮件发送*/
    okClickHandler() {
      if (!this.toCheckEmailForm()) {
        return
      }
      this.toLocalCache()
      // 保存默认抄送人
      this.saveCCEmail()
      let mailContent = this.emailForm.mailContent ? this.emailForm.mailContent.split('\n').join('<br/>') : ''
      if (mailContent) {
        const list = mailContent.split('</p>')
        if (list && list.length > 0) {
          for (const item of list) {
            if (item && item.indexOf('<a href=') > -1 && item.indexOf('</a>') > -1) {
              const oldValue = item
              let newValue = item.replaceAll('<p>', '').replaceAll('</p>', '')
              if (newValue) {
                const subString = 'target="_blank">'
                const firstIndex = newValue.indexOf(subString)
                const lastIndex = newValue.indexOf('</a>')
                if (firstIndex > -1 && lastIndex > -1 && lastIndex >= firstIndex + subString.length) {
                  newValue = newValue.substring(firstIndex + subString.length, lastIndex)
                  if (newValue) {
                    newValue = '<p><a href="' + newValue + '" rel="noopener noreferrer" ' + subString + newValue + '</a>'
                    mailContent = mailContent.replace(oldValue, newValue)
                  }
                }
              }
            }
          }
        }
      }
      if (this.sendCallBack) {
        this.sendCallBack(this.emailForm.title, this.emailForm.to, this.emailForm.cc, this.emailForm.content, this.emailForm.mailType, mailContent, this.emailForm.pushLink, this.customerTypeName)
        return
      }
      const emailForm = {}
      Object.assign(emailForm, this.emailForm)
      emailForm.mailContent = mailContent
      fileHistorySendEmailService(emailForm).then(res => {
        if (res.ok) {
          this.innerVisible = false
          this.$message({
            type: 'success',
            message: this.$t(`Message.TheFileIsSentSuccessfully`)
          })
        } else {
          this.$message({
            type: 'info',
            message: this.$t('SeaExport.MailSendingFailed')
          })
        }
      }).catch(() => {
        // this.$message.error(err)
      })
    },
    localEmailClickHandler() {
      // if (!this.toCheckEmailForm()) return
      this.toLocalCache()
      let mailTo = 'mailto:' + this.emailForm.to + '?'
      if (this.emailForm.title != '') {
        mailTo += 'subject=' + this.emailForm.title
      }
      if (this.emailForm.cc != '') {
        mailTo += '&cc=' + this.emailForm.cc
      }
      if (this.emailForm.content) {
        mailTo += '&body=' + this.emailForm.content
      }

      parent.location.href = mailTo
    },
    toCheckEmailForm: function() {
      let errorMsg = ''
      if (!this.emailForm.to) {
        errorMsg += this.$t('Message.EmailAddressCannotBeEmpty')
      }
      if (this.isEmailGroup && this.emailForm.to) { // 收件群组
        this.emailForm.to = this.emailForm.to.replaceAll('\n', '')
        this.emailForm.to = this.emailForm.to.replaceAll(';', ',')
      }
      if (this.emailGroup && this.emailForm.cc) { // 抄送群组
        this.emailForm.cc = this.emailForm.cc.replaceAll('\n', '')
        this.emailForm.cc = this.emailForm.cc.replaceAll(';', ',')
      }
      if (errorMsg) {
        this.$message.error(errorMsg)
        return false
      } else {
        return true
      }
    },
    // 做本地缓存
    toLocalCache() {
      if (!this.source) {
        return
      }
      LocalStorageUtilsNew.setConfiguration(this.source + 'EmailInput' + this.customerType, {
        customerType: this.customerType,
        customerTypeName: this.customerTypeName,
        sales: this.sales,
        op: this.op,
        csr: this.csr,
        doc: this.doc,
        emailGroup: this.emailGroup,
        defaultCc: this.defaultCc,
        emailGroupTo: this.emailGroupTo.join(','),
        emailGroupCc: this.emailGroupCc.join(','),
        cc: this.emailForm.cc,
        mailType: this.emailForm.mailType
      })
    },
    otherHandler() {
      // 原切换方法
      this.changeHandler()
      // 切换推送对象时，切换邮件模版
      this.initEmailTemplateList()
      const localObj = LocalStorageUtilsNew.getConfiguration(this.source + 'SendEmailDialog' + this.customerType)
      if (localObj) {
        this.doLocalCache(localObj)
      }
    },
    /* 客户类型选择*/
    changeHandler() {
      this.emailForm.to = ''
      this.emailToList = []
      this.contactList = null
      if (this.customerType !== 6) { // 不为指定货代理的时候
        this.reductionLink()
      }
      switch (this.customerType) {
        case 1:
          this.customerId = this.job.customerId
          this.customerTypeName = 'customer'
          this.getCompany({ cmpIdx: this.customerId })
          break
        case 2:
          this.customerId = this.job.carrierId
          this.customerTypeName = 'seaCmp'
          this.getCarrierCompany({ cmpIdx: this.customerId })
          break
        case 3:
          this.customerId = this.job.bookingAgent
          this.customerTypeName = 'bookingAgent'
          this.getCompany({ cmpIdx: this.customerId })
          break
        case 4:
          this.customerId = this.job.localAgent
          this.customerTypeName = 'localAgent'
          this.getCompany({ cmpIdx: this.customerId })
          break
        case 5:
          this.customerId = this.job.destinationAgent
          this.customerTypeName = 'designationAgent'
          this.getCompany({ cmpIdx: this.customerId })
          break
        case 6:
          this.customerId = this.job.designationAgent
          this.customerTypeName = 'designationAgent'
          this.getCompany({ cmpIdx: this.customerId })
          // 替换对单地址为海外代理对单链接
          if (cache.config.get('ToExoSystem') === 'JYD') {
            this.replaceToOverseasLink()
          }
          break
        case 7:
          this.customerId = 0
          this.customerTypeName = 'truckCmp'
          this.loadTruckingResultHandler()
          break
        case 8:
          this.customerId = 0
          this.customerTypeName = 'warehouse'
          this.loadWarehouseSuccess()
          break
        case 10:
          this.customerId = this.job.shipperId
          this.customerTypeName = 'shipper'
          this.getCompany({ cmpIdx: this.customerId })
          break
        case 11:
          this.customerId = this.job.consigneeId
          this.customerTypeName = 'consignee'
          this.getCompany({ cmpIdx: this.customerId })
          break
        case 12:
          this.customerId = this.job.notifyId
          this.customerTypeName = 'notify'
          this.getCompany({ cmpIdx: this.customerId })
          break
      }
    },
    /* 获取默认联系人*/
    getDefaultEmail(contacts) {
      if (contacts && contacts.length > 0) {
        for (const contact of contacts) {
          if (contact.contactPerson === this.job.customerContact) {
            const item = {
              name: `[${contact.contactPerson}]${contact.email}`,
              contact: contact.contactPerson,
              email: contact.email
            }
            return item
          }
        }
      }
      return null
    },
    // 获取当前用户有权限的群组
    async initEmailGroupList() {
      this.emailGroupToList = []
      this.emailGroupCcList = []
      const params = {}
      const checkOwner = this.$checkPermission(['role_MailGroup_userSelf']) // 查看自己的数据及公共的数据
      if (checkOwner) params.checkOwner = true
      const checkAll = this.$checkPermission(['role_MailGroup_all']) // 查看全部数据
      if (checkAll) params.checkAll = true
      await getMailGroupList(params).then(res => {
        const emailGroupList = res.data.list
        if (!emailGroupList || emailGroupList.length <= 0) return
        for (const group of emailGroupList) {
          if (group.groupSceneTo) {
            this.emailGroupToList.push(group)
          }
          if (group.groupSceneCc) {
            this.emailGroupCcList.push(group)
          }
        }
      })
    },
    // 获取当前分公司的邮件模板
    initEmailTemplateList() {
      this.emailTemplateList = []
      const data = {
        multipleOfficeIdList: [this.job.opOffice],
        branchId: this.$store.getters.currentOfficeId,
        lob: this.job.lob,
        multipleAccountIdList: [this.customerType],
        pushLink: this.pushLink
      }
      userApi.getMailTemplateByParams(data).then((res) => {
        this.emailTemplateList = res.data || []
        // 如果已经有邮件模版 ，检查下新列表有没有，没有就删了
        if (this.emailForm && this.emailForm.emailTitle) {
          const has = this.emailTemplateList.filter(p => p.templateName === this.emailForm.emailTitle)
          if (!has || has.length === 0) {
            this.emailForm.emailTitle = ''
            this.emailTemplateChange('init')
          }
        }
      })
    },
    // 收件人邮件群组改变
    emailGroupToChange(items) {
      const emails = []
      for (const option of this.emailGroupToList) {
        if (items.includes(option.uuid) && option.emailAddress) {
          const items = option.emailAddress.split('\n')
          for (const item of items) {
            if (!emails.includes(item)) {
              emails.push(item)
            }
          }
        }
      }
      this.emailForm.to = emails.join('\n')
    },
    // 抄送邮件群组改变
    emailGroupCcChange(items) {
      const emails = []
      for (const option of this.emailGroupCcList) {
        if (items.includes(option.uuid) && option.emailAddress) {
          const items = option.emailAddress.split('\n')
          for (const item of items) {
            if (!emails.includes(item)) {
              emails.push(item)
            }
          }
        }
      }
      this.emailForm.cc = emails.join('\n')
    },
    emailToChange(val) {
      if (val && val.length > 0) {
        this.emailForm.to = val.join(',')
      }
    },
    doLocalCache(localObj) {
      this.customerType = localObj.customerType
      this.customerTypeName = localObj.customerTypeName
      this.sales = localObj.sales
      this.op = localObj.op
      this.csr = localObj.csr
      this.doc = localObj.doc
      this.emailGroup = localObj.emailGroup
      this.defaultCc = localObj.defaultCc
      this.emailGroupTo = localObj.emailGroupTo ? localObj.emailGroupTo.split(',') : []
      this.emailGroupCc = localObj.emailGroupCc ? localObj.emailGroupCc.split(',') : []
      this.emailForm.mailType = localObj.mailType
      if (this.isEmailGroup && this.emailGroupTo && this.emailGroupTo.length > 0) {
        this.emailGroupToChange(this.emailGroupTo)
      }
      if (this.emailGroup && this.emailGroupCc && this.emailGroupCc.length > 0) {
        this.emailGroupCcChange(this.emailGroupCc)
      } else {
        if (localObj) {
          this.emailForm.cc = localObj.cc
        }
        if (this.sales && this.job.sales) {
          const userEmail = resolveSpecificField2Value(TYPE_NAMES.basic_data_User, 'userId', this.job.sales, 'email')
          if (userEmail) {
            this.ccList.push(userEmail)
          }
        }
        if (this.op && this.job.op) {
          const userEmail = resolveSpecificField2Value(TYPE_NAMES.basic_data_User, 'userId', this.job.op, 'email')
          if (userEmail) {
            this.ccList.push(userEmail)
          }
        }
        if (this.csr && this.job.csr) {
          const userEmail = resolveSpecificField2Value(TYPE_NAMES.basic_data_User, 'userId', this.job.csr, 'email')
          if (userEmail) {
            this.ccList.push(userEmail)
          }
        }
        if (this.doc && this.job.dc) {
          const userEmail = resolveSpecificField2Value(TYPE_NAMES.basic_data_User, 'userId', this.job.dc, 'email')
          if (userEmail) {
            this.ccList.push(userEmail)
          }
        }
        // 刷新CC内容
        this.refreshCcTxt()
      }
    },
    // 邮件模板改变
    emailTemplateChange(type, item) {
      const option = this.emailTemplateList.find(p => p.uuid === item)
      this.emailForm.title = option ? option.themeTemplate : ''
      this.emailForm.mailContent = option ? option.contentTemplate : ''

      // 根据模版填充默认值
      this.sales = option ? option.sales : ''
      this.op = option ? option.op : ''
      this.csr = option ? option.csr : ''
      this.doc = option ? option.doc : ''
      this.emailGroup = option ? option.emailGroup : ''
      this.emailGroupCc = option && option.emailGroupCc ? option.emailGroupCc.split(',') : []
      const data = {
        jobuuid: this.job.jobUuid,
        pushLink: '',
        templateUuid: option.uuid
      }
      if (type === 'change') {
        this.getSetMailTemplateFunc(data, type)
      }
      // 页面联动逻辑
      const ccHandlers = {
        'sales': this.sales,
        'op': this.op,
        'csr': this.csr,
        'doc': this.doc,
        '': this.emailGroup
      }
      for (const [key, value] of Object.entries(ccHandlers)) {
        this.ccChangeHandler(key, value)
      }
    },
    // 主题模板
    titleLabelFunction(item) {
      return `${item.templateName}`
    },
    // 清空抄送人
    onClearCc(val) {
      this.emailGroupCc = ''
      this.emailForm.cc = ''
    },
    // 清空标题
    onClearTitle() {
      this.emailForm.title = ''
    },
    // 清空值
    emailTemplateCheck() {
      if (!this.emailTemplate) {
        this.emailForm.title = ''
        this.emailForm.emailTitle = ''
        // this.emailForm.mailContent = this.storageMailContent
      }
    },
    onCopyLink() {
      if (!this.emailForm.content) {
        this.$message.warning(this.$t('SeaExport.LinkIsNull'))
        return
      }
      const textarea = document.createElement('textarea')
      document.body.appendChild(textarea)
      textarea.textContent = this.emailForm.content
      textarea.select()
      if (document.execCommand('copy')) {
        document.execCommand('copy')
      }
      document.body.removeChild(textarea)
      this.$message.success(this.$t('SeaExport.CopySuccess'))
    },
    onOpenLink() {
      if (!this.emailForm.content) {
        this.$message.warning(this.$t('SeaExport.LinkIsNull'))
        return
      }
      window.open(this.emailForm.content)
    },
    // 替换为海外对单链接
    replaceToOverseasLink() {
      if (this.sendEmailData) {
        this.emailForm.content = this.sendEmailData.overseasLink
        this.emailForm.mailContent = this.overseasMailContent
      }
    },
    // 还原链接
    reductionLink() {
      if (this.sendEmailData) {
        this.emailForm.content = this.sendEmailData.emailContent
        this.emailForm.mailContent = this.mailContent
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.app-main-inner-row{
  display: flex;
  flex-direction: column;
  /deep/ .el-radio-group{
    width: 100%;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: flex-start;
    align-items: center;
    .el-radio{
      width: 24%;
      height: 30px;
      margin-right: 0;
    }
  }
  .el-form{
    width: 100%;
    margin-top: 10px;
    .el-form-item{
      margin-bottom: 12px !important;
      margin-right: 27px;
      &.short{
        /deep/ .el-form-item__content{
          width: 222px;
          .el-input{
            width: 100%;
          }
        }
      }
      &.long{
        width: 100%;
        /deep/ .el-form-item__content{
          width: 85%;
          .el-input{
            width: 541px;
          }
          .el-textarea{
            width: 541px;
            height: 90px;
            textarea{
              height: 90px;
              resize: none;
            }
          }
        }

      }
      &.long2{
        width: 100%;
        /deep/ .el-form-item__content{
          width: 85%;
          .el-input{
            width: 455px;
          }
        }
      }
      &.placeholder-margin /deep/ .el-form-item__content .el-select__input {
        margin-left: 10px;
      }
    }
  }
}
</style>

<!--不加 scoped， 否则组件样式不能注入-->
<style lang="scss">
.app-main-inner {
  .my-custom-quill-editor-email-input .ql-toolbar.ql-snow + .ql-container.ql-snow {
    height: 100px;
    resize: vertical;
    overflow: auto;
  }
}
</style>
